import { useState, useEffect, useCallback } from 'react'
import { Link } from 'react-router-dom'
import { retrieveProduct } from './dataRetrieval'
import { filterList } from './filterList'
import integration from './integrationReport.json'
import { get_doc_title } from './common'

function ModelSearch() {
  const handleSearch = useCallback((e) => {
    e.preventDefault()

    const sku = document.querySelector('#sku')
    const feedback = document.querySelector('.feedback')
    const button = document.querySelector('button')

    if (
      sku.value &&
      sku.value.trim() !== '' &&
      !button.hasAttribute('disabled')
    ) {
      const sku_trimmed = sku.value.trim().toUpperCase()

      button.setAttribute('disabled', 'disabled')

      retrieveProduct(sku_trimmed).then((response) => {
        feedback.innerHTML = ''
        feedback.classList.add('hidden')

        if (response === false) {
          button.removeAttribute('disabled')

          feedback.innerHTML = feedback
            .getAttribute('data-nok')
            .replace('%s', sku_trimmed)
          feedback.classList.remove('hidden')
        } else {
          window.location = `/model/${sku_trimmed}`
        }
      })
    }
  })

  // doc title
  useEffect(() => {
    document.title = get_doc_title()
  }, [])

  return (
    <div className="search-wrap">
      <h2>Fill in your model SKU</h2>
      <form action="/" method="POST" onSubmit={handleSearch}>
        <label className="hidden" htmlFor="sku">
          SKU
        </label>
        <input name="sku" id="sku" type="text" />
        <button type="submit" id="sku_send">
          Search
        </button>
      </form>
      <div
        className="feedback hidden"
        data-nok='Model "%s" not found in the API...<br />Please check the syntax and try again.'
      ></div>
    </div>
  )
}

export default ModelSearch
